<template>
  <div>
    <v-container style="margin-top: 16px">
      <span class="subtitle">{{ $t('preguntasFrecuentes') }}</span>

      <v-expansion-panels style="margin-top: 16px">
        <v-expansion-panel v-for="(faq, index) in preguntas" :key="faq.pregunta" style="margin-bottom: 7px">
          
            <v-expansion-panel-header class="body-1" style="color: white; background: #1ab9e4">{{ $t(faq.pregunta) }}</v-expansion-panel-header>
            <v-expansion-panel-content class="body-2" style="margin-top: 16px; font-weight: 300">
              <p>{{ $t(faq.parrafo1) }}</p>
              <div v-if= "index==8">
                <p>
                  {{ $t(faq.parrafo2) }} <a href="https://www.google.es/maps/dir/P%C3%A0rquing+Barcelona+Port,+Terminal+E,+Moll+Adossat,+08039+Barcelona//@41.3557162,2.1689873,15z/data=!4m9!4m8!1m5!1m1!1s0x12a4a34b3c88a515:0xe8c564aa31e6725d!2m2!1d2.1737058!2d41.3498438!1m0!3e2">{{ $t(faq.link) }}</a>{{ $t(faq.parrafo3) }}
                </p>  
              </div>  
              <div v-else>
                <p>{{ $t(faq.parrafo2) }}</p>
                <p>{{ $t(faq.parrafo3) }}</p>
              </div>  
            </v-expansion-panel-content>

        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaFAQ",

  data: () => ({
    preguntas: [
      {
        pregunta: "pregunta1",
        parrafo1: "pregunta1Parrafo1",
        parrafo2: "pregunta1Parrafo2",
        parrafo3: "pregunta1Parrafo3"
      },
      {
        pregunta: "pregunta2",
        parrafo1: "pregunta2Parrafo1",
        parrafo2: "pregunta2Parrafo2",
        parrafo3: "pregunta2Parrafo3"
      },
      {
        pregunta: "pregunta3",
        parrafo1: "pregunta3Parrafo1",
        parrafo2: "pregunta3Parrafo2",
        parrafo3: "pregunta3Parrafo3"
      },
      {
        pregunta: "pregunta4",
        parrafo1: "pregunta4Parrafo1",
        parrafo2: "pregunta4Parrafo2",
        parrafo3: "pregunta4Parrafo3"
      },
      {
        pregunta: "pregunta5",
        parrafo1: "pregunta5Parrafo1",
        parrafo2: "pregunta5Parrafo2",
        parrafo3: "pregunta5Parrafo3"
      },
      {
        pregunta: "pregunta6",
        parrafo1: "pregunta6Parrafo1",
        parrafo2: "pregunta6Parrafo2",
        parrafo3: "pregunta6Parrafo3"
      },
      {
        pregunta: "pregunta7",
        parrafo1: "pregunta7Parrafo1",
        parrafo2: "pregunta7Parrafo2",
        parrafo3: "pregunta7Parrafo3"
      },
      {
        pregunta: "pregunta8",
        parrafo1: "pregunta8Parrafo1",
        parrafo2: "pregunta8Parrafo2",
        parrafo3: "pregunta8Parrafo3"
      },
      {
        pregunta: "pregunta9",
        parrafo1: "pregunta9Parrafo1",
        parrafo2: "pregunta9Parrafo2",
        parrafo3: "pregunta9Parrafo3",
        link: "pregunta9link"
      },
      {
        pregunta: "pregunta10",
        parrafo1: "pregunta10Parrafo1",
        parrafo2: "pregunta10Parrafo2",
        parrafo3: "pregunta10Parrafo3"
      },
      {
        pregunta: "pregunta11",
        parrafo1: "pregunta11Parrafo1",
        parrafo2: "pregunta11Parrafo2",
        parrafo3: "pregunta11Parrafo3"
      },
      {
        pregunta: "pregunta12",
        parrafo1: "pregunta12Parrafo1",
        parrafo2: "pregunta12Parrafo2",
        parrafo3: "pregunta12Parrafo3"
      },
      {
        pregunta: "pregunta13",
        parrafo1: "pregunta13Parrafo1",
        parrafo2: "pregunta13Parrafo2",
        parrafo3: "pregunta13Parrafo3"
      },
      {
        pregunta: "pregunta14",
        parrafo1: "pregunta14Parrafo1",
        parrafo2: "pregunta14Parrafo2",
        parrafo3: "pregunta14Parrafo3"
      },
      {
        pregunta: "pregunta15",
        parrafo1: "pregunta15Parrafo1",
        parrafo2: "pregunta15Parrafo2",
        parrafo3: "pregunta15Parrafo3"
      },
      {
        pregunta: "pregunta16",
        parrafo1: "pregunta16Parrafo1",
        parrafo2: "pregunta16Parrafo2",
        parrafo3: "pregunta16Parrafo3"
      },


    ] // fin array preguntas
  })  // fin objeto data
};
</script>
